import { Button } from "@components/index";
import Address from "assets/svg/address.svg";
import Phone from "assets/svg/cell-phone.svg";
import DownloadYellow from "assets/svg/download-yellow.svg";
import Aparat from "assets/svg/footer/aparat.svg";
import Bale from "assets/svg/footer/baleh.svg";
import Eitaa from "assets/svg/footer/ita.svg";
import Insta from "assets/svg/social-network/insta.svg";
import Linkedin from "assets/svg/social-network/linkedin.svg";
import Telegram from "assets/svg/social-network/telegram.svg";
import Twitter from "assets/svg/social-network/twitter.svg";
import { useRouter } from "next/router";
import React from "react";

import styles from "./style.module.css";

const Footer: React.FC = () => {
  const router = useRouter();
  return (
    <footer className="bg-black px-9 py-8 text-white md:px-[10%] md:py-[70px]">
      <div className={styles.grid_container}>
        <div className={styles.first}>
          <p className="mb-[42px] text-teal-450">مؤسسه حقوقی دادبانان</p>
          <p>
            <a href="tel:02175323000" className="mt-10 text-sm font-thin">
              واحد آموزش و ثبت نام : ۰۰۰ ۲۳ ۷۵۳ - ۰۲۱
            </a>
          </p>
          <p>
            <a href="tel:09104502525" className="text-sm font-thin">
              موبایل و واتس‌اپ واحد آموزش : ۲۵ ۲۵ ۴۵۰ ۰۹۱۰
            </a>
          </p>
          <p>
            <a href="tel:09354979797" className="text-sm font-thin">
              آموزش آفلاین (دادبانان پلاس) : 97 97 497 0935
            </a>
          </p>
          <p>
            <a href="tel:02122580137" className="text-sm font-thin">
              رزرو مشاوره حضوری : ۳۷ ۰۱ ۵۸ ۲۲ – ۰۲۱
            </a>
          </p>
          <p>
            <a href="tel:02122584900" className="text-sm font-thin">
              واحد انتشارات‌ : ۰۰ ۴۹ ۵۸ ۲۲ - ۰۲۱
            </a>
          </p>
          <p>
            <a href="tel:09915050789" className="text-sm font-thin">
              موبایل و واتس‌اپ واحد انتشارات : ۷۸۹ ۵۰ ۵۰ ۰۹۹۱
            </a>
          </p>
        </div>
        <div className={styles.second}>
          <p className="mb-[42px] text-center text-teal-450">تماس با ما</p>
          <div className="grid grid-cols-1 gap-y-4 md:grid-cols-[_1fr,_1.5fr,_1fr] md:gap-0">
            <div className="flex flex-col items-center text-sm">
              <Phone className="mb-[10px]" />
              <span className="mb-6">تلفن</span>
              <a
                href="tel:02175323000"
                className="w-min whitespace-nowrap rounded-full border border-teal-450 px-4 py-1"
              >
                ۰۰۰ ۲۳ ۷۵۳ - ۰۲۱
              </a>
            </div>
            <div className="flex flex-col items-center text-sm">
              <a
                href="https://www.google.com/maps/dir//%D9%85%D9%88%D8%B3%D8%B3%D9%87+%D8%AD%D9%82%D9%88%D9%82%DB%8C+%D8%AF%D8%A7%D8%AF%D8%A8%D8%A7%D9%86%D8%A7%D9%86+Tehran+unit+3,+2nd+Floor,+No.+183,+EN+Bank+Building+Kolahdouz+St%E2%80%AD/@35.780604,51.4583868,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x3f8e0445f442be0f:0x8875e9d634b2ca85"
                target={"_blank"}
                rel="noreferrer"
                aria-label="dadbanan address"
              >
                <Address className="mb-[10px]" />
              </a>
              <span className="mb-6">آدرس</span>
              <span className="w-full rounded-full border border-teal-450 px-4 py-1 text-center">
                خیابان دولت، بین دیباجی و یارمحمدی، نبش کوچه طالقانی (حافظ)،
                ساختمان بانک اقتصاد نوین، پلاک ۱، طبقه ۲، واحد ۳
                <span className="block">کدپستی : 1951636718</span>
              </span>
            </div>
            <div className="flex flex-col items-center">
              <DownloadYellow className="mb-[6px] ml-2" />
              <span className="mb-6 text-lg text-yellow-350">اپلیکیشن ما</span>
              <Button
                onClick={() => router.push("/app-download")}
                CClassName="h-[39px] whitespace-nowrap px-4 bg-[#FBCF32] text-black text-base rounded-full"
              >
                دانلود اپلیکیشن دادبانان
              </Button>
            </div>
          </div>
        </div>

        <a
          referrerPolicy="origin"
          href="https://trustseal.enamad.ir/?id=259514&Code=58nQnx8tRD9dpKQ0ygUd"
          target="_blank"
          rel="noopener"
          aria-label="enamad"
          className="block md:hidden"
        >
          <img
            referrerPolicy="origin"
            loading="lazy"
            id="58nQnx8tRD9dpKQ0ygUd"
            code="58nQnx8tRD9dpKQ0ygUd"
            src="https://trustseal.enamad.ir/logo.aspx?id=259514&Code=58nQnx8tRD9dpKQ0ygUd"
            alt=""
            className="mx-auto mt-5 cursor-pointer"
          />
        </a>

        <div className={styles.third}>
          <p className="mb-[42px] text-teal-450">دادبانان دانا</p>
          <ul className="space-y-3 text-sm">
            <li>
              ایمیل :{" "}
              <a href="email:Dadbanandanalawfirm@gmail.com">
                Dadbanandanalawfirm@gmail.com
              </a>
            </li>
            <li>
              فکس : <a href="tel:02122580237">۳۷ ۰۲ ۵۸ ۲۲ – ۰۲۱</a>
            </li>
            <li>
              <a
                referrerPolicy="origin"
                href="https://trustseal.enamad.ir/?id=259514&Code=58nQnx8tRD9dpKQ0ygUd"
                target="_blank"
                rel="noopener"
                aria-label="enamad"
              >
                <img
                  referrerPolicy="origin"
                  loading="lazy"
                  id="58nQnx8tRD9dpKQ0ygUd"
                  code="58nQnx8tRD9dpKQ0ygUd"
                  src="https://trustseal.enamad.ir/logo.aspx?id=259514&Code=58nQnx8tRD9dpKQ0ygUd"
                  alt=""
                  className="cursor-pointer"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-[60px] flex flex-col items-center gap-y-5 md:flex-row md:justify-center md:gap-y-0">
        <div className="flex items-center justify-center gap-x-4 md:contents">
        <a
          rel="noreferrer"
          aria-label="instagram"
          href="https://www.instagram.com/dadbanan/"
          target={"_blank"}
        >
          <Insta className="transition-all hover:invert-[.25]" />
        </a>
        <a
          href="https://twitter.com/FDadbanan?s=12"
          aria-label="twitter"
          rel="noreferrer"
          target={"_blank"}
        >
          <Twitter className="md:mx-5 transition-all hover:invert-[.25]" />
        </a>
        <a
          rel="noreferrer"
          aria-label="telegram"
          href="https://t.me/dadbanandanalawfirm/3388"
          target={"_blank"}
        >
          <Telegram className="transition-all hover:invert-[.25]" />
        </a>
        <a
          aria-label="linkedin"
          href="https://www.linkedin.com/company/dadbanan/"
          rel="noreferrer"
          target={"_blank"}
        >
          <Linkedin className="md:mx-5 transition-all hover:invert-[.25]" />
        </a>
        </div>
        <div className="flex items-center justify-center gap-x-4 md:contents">
        <a
          rel="noreferrer"
          aria-label="aparat"
          href="https://www.aparat.com/dadbanandana"
          target={"_blank"}
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white transition-all hover:invert-[.25]">
            <Aparat className="h-7 w-7 fill-black" />
          </span>
        </a>
        <a
          rel="noreferrer"
          aria-label="eitaa"
          href="https://eitaa.com/dadbanandana"
          target={"_blank"}
        >
          <span className="md:mx-5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white transition-all hover:invert-[.25]">
            <Eitaa className="h-7 w-7 fill-black" />
          </span>
        </a>
        <a
          rel="noreferrer"
          aria-label="bale"
          href="https://ble.ir/dadbanancom"
          target={"_blank"}
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white transition-all hover:invert-[.25]">
            <Bale className="h-7 w-7 fill-black" />
          </span>
        </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
